namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.SegmentCriteriaGrid')
    export class SegmentCriteriaGrid extends Serenity.EntityGrid<SegmentCriteriaRow, any> {
        protected getColumnsKey() { return SegmentCriteriaColumns.columnsKey; }
        protected getDialogType() { return SegmentCriteriaDialog; }
        protected getIdProperty() { return SegmentCriteriaRow.idProperty; }
        protected getInsertPermission() { return SegmentCriteriaRow.insertPermission; }
        protected getLocalTextPrefix() { return SegmentCriteriaRow.localTextPrefix; }
        protected getService() { return SegmentCriteriaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}